<div class="setting-page">
  <legend>QoS</legend>
  <arm-form (submitForm)="submit()" [disableSubmit]="!canSubmit">
    <arm-form-title>QOS Values</arm-form-title>
    <div class="settings-section">
      <form #mapForm="ngForm">
       <p>
        <mat-form-field class="halfWidth">
          <mat-label>Gold (HTTP/S, JMS, NTP)</mat-label>
          <input type="number" [(ngModel)]="qosSettings.gold" matInput name="gold"  [min]="0" [max]="63" required>
          <mat-error>
            value range between 0 to 63
          </mat-error>
        </mat-form-field>
       </p>

        <p>
          <mat-form-field class="halfWidth">
            <mat-label>Silver (SNMP, CDR, Syslog, LDAP)</mat-label>
            <input type="number" [(ngModel)]="qosSettings.silver" matInput name="silver"  [min]="0" [max]="63" required>
            <mat-error>
              value range between 0 to 63
            </mat-error>
          </mat-form-field>
        </p>
        <p>
          <mat-form-field class="halfWidth">
            <mat-label>Bronze (SSH)</mat-label>
            <input type="number" [(ngModel)]="qosSettings.bronze" matInput name="bronze"  [min]="0" [max]="63" required>
            <mat-error>
              value range between 0 to 63
            </mat-error>
          </mat-form-field>
        </p>
      </form>

    </div>
  </arm-form>
</div>
